// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"783":"d7bcd98c","993":"70946c8c"}[chunkId] + ".chunk.js";
};